import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';

const getProtectionPlan = (state, ownProps) =>
    !isEmpty(state.bundleProtectionPlan)
        ? state.bundleProtectionPlan[ownProps.productDetails.id]
        : '';

const selectedProtectionPlan = createSelector(
    [getProtectionPlan],
    (protectionPlan) => protectionPlan
);

export default selectedProtectionPlan;
